


import axiosInstance from "./AxiosInstance";

export const getDashboardOverview = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/overview", { params, timeout: 60000 });
  return response.data;
};

export const getDashboardMetrics = async () => {
  const response = await axiosInstance.get("/dashboard/metrics", { timeout: 30000 });
  return response.data;
};

// Six months of the rates the admin dashboard charts, plus the enrolment
// counts behind them. Rates come back as 0-100 or null; null means the
// underlying records do not exist, which the chart must show as absent
// rather than as zero.
export const getDashboardPulse = async (months = 6) => {
  const response = await axiosInstance.get("/dashboard/pulse", {
    params: { months },
    timeout: 60000,
  });
  return response.data;
};

// Attendance per batch, banded good / fair / poor. Rates are the share of
// seats filled across every session the batch has run.
export const getBatchAttendance = async (limit = 12) => {
  const response = await axiosInstance.get("/dashboard/batch-attendance", {
    params: { limit },
    timeout: 60000,
  });
  return response.data;
};

export const getDashboardTabData = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/tab-data", {
    params,
    timeout: 30000,
  });
  return response.data;
};

export const getDashboardTabDetail = async (tab, id) => {
  const response = await axiosInstance.get(`/dashboard/tab-data/${tab}/${id}`, {
    timeout: 30000,
  });
  return response.data;
};

// The admin dashboard's Students tab: one row per student, with courseNames,
// courseAssignments and assignedBatches already worked out by the API.
export const getDashboardStudents = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/students", {
    params,
    timeout: 60000,
  });
  return response.data;
};

// One student in full for the admin's student popup -- batches, attendance
// tallies and quiz history, all counted by the API.
export const getDashboardStudentView = async (studentId) => {
  const response = await axiosInstance.get(`/dashboard/student-view/${studentId}`, {
    timeout: 60000,
  });
  return response.data;
};

export const getStudentTabData = async (params = {}) => {
  const response = await axiosInstance.get("/receipts/studenttab", {
    params,
    timeout: 60000,
  });
  return response.data;
};

export const getBatchedStudents = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/batchedstudents", {
    params,
    timeout: 30000,
  });
  return response.data;
};

export const getFullStudent = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/fullstudent", {
    params,
    timeout: 30000,
  });
  return response.data;
};

export const getStudentAttendance = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/studentattendance", {
    params,
    timeout: 30000,
  });
  return response.data;
};

export const getStudentQuizHistory = async (params = {}) => {
  const response = await axiosInstance.get("/dashboard/studentquizes", {
    params,
    timeout: 30000,
  });
  return response.data;
};
